(function () {
  'use strict';
  class PetPulseQuiz {
    constructor(root, catalogueEl) {
      if (!root || !catalogueEl) return;
      this.root = root;
      this.answers = { petType: null, size: null, need: null };
      this.stepOrder = ['1', '2', '3', 'results'];
      this.currentIndex = 0;
      try { this.catalogue = JSON.parse(catalogueEl.textContent || '[]'); } catch (e) { this.catalogue = []; }
      this.bindEvents();
    }
    bindEvents() {
      this.root.querySelectorAll('.pp-quiz__option').forEach((btn) => { btn.addEventListener('click', () => this.selectOption(btn)); });
      this.root.querySelectorAll('[data-quiz-back]').forEach((btn) => { btn.addEventListener('click', () => this.goToStep(this.currentIndex - 1)); });
      const restartBtn = this.root.querySelector('[data-quiz-restart]');
      if (restartBtn) restartBtn.addEventListener('click', () => this.restart());
    }
    selectOption(btn) {
      const group = btn.closest('[data-question]');
      const question = group.getAttribute('data-question');
      const value = btn.getAttribute('data-value');
      group.querySelectorAll('.pp-quiz__option').forEach((el) => el.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.answers[question] = value;
      window.setTimeout(() => {
        if (this.currentIndex < 2) { this.goToStep(this.currentIndex + 1); }
        else { this.renderResults(); this.goToStep(this.currentIndex + 1); }
      }, 220);
    }
    goToStep(index) {
      if (index < 0 || index >= this.stepOrder.length) return;
      this.currentIndex = index;
      const target = this.stepOrder[index];
      this.root.querySelectorAll('.pp-quiz__step').forEach((step) => { step.classList.toggle('is-active', step.getAttribute('data-step') === target); });
      const progressDots = this.root.querySelectorAll('.pp-quiz__progress span');
      progressDots.forEach((dot, i) => dot.classList.toggle('is-active', i <= index && target !== 'results' ? i <= index : i < 3));
      if (target === 'results') { progressDots.forEach((dot) => dot.classList.add('is-active')); }
    }
    renderResults() {
      const { petType, size, need } = this.answers;
      const wanted = [petType, size, need].filter(Boolean).map((v) => v.toLowerCase());
      const scored = this.catalogue.map((product) => {
        const tags = (product.tags || []).map((t) => String(t).toLowerCase());
        const score = wanted.reduce((acc, w) => acc + (tags.includes(w) ? 1 : 0), 0);
        return { product, score };
      });
      scored.sort((a, b) => b.score - a.score);
      let results = scored.filter((r) => r.score > 0).slice(0, 6);
      if (results.length === 0) { results = scored.slice(0, 4); }
      const container = this.root.querySelector('[data-quiz-results]');
      if (!container) return;
      if (results.length === 0) { container.innerHTML = '<p class="pp-body">We could not find a match yet — check back soon!</p>'; return; }
      container.innerHTML = results.map(({ product }) => `
        <a href="${product.url}" class="pp-card" style="text-decoration:none; display:block;">
          <div class="pp-product-card__media">
            ${product.image ? `<img src="${product.image}" alt="${this.escapeHtml(product.title)}" loading="lazy">` : ''}
          </div>
          <div class="pp-product-card__body" style="padding:14px;">
            <p class="pp-product-card__title">${this.escapeHtml(product.title)}</p>
            <p class="pp-price">${product.price}</p>
          </div>
        </a>`).join('');
    }
    restart() {
      this.answers = { petType: null, size: null, need: null };
      this.root.querySelectorAll('.pp-quiz__option').forEach((el) => el.classList.remove('is-selected'));
      this.goToStep(0);
    }
    escapeHtml(str) { const div = document.createElement('div'); div.textContent = str || ''; return div.innerHTML; }
  }
  window.PetPulseQuiz = PetPulseQuiz;
})();
